import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export function StoreComparisonCard({ selectedProducts, storeComparisonData }) {
  const storeData = (storeComparisonData || []).map(item => ({
    store: item.store,
    totalPrice: item.total_price,
    items: item.items
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-card p-3" style={{ border: '1px solid var(--color-border)' }}>
          <p className="small mb-2 fw-semibold">{label}</p>
          <p className="small text-primary-custom mb-1">
            Valor Total: R${payload[0].value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <p className="small text-muted-custom mb-0">
            Produtos: {payload[0].payload.items}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="h5 fw-semibold mb-0">Valor total por loja</h3>
          <span className="badge badge-secondary-custom">{storeData.length} lojas</span>
        </div>

        {selectedProducts.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center height-280">
            <p className="text-muted-custom">Selecione produtos para comparar os preços totais por loja.</p>
          </div>
        ) : storeData.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center height-280">
            <p className="text-muted-custom">Nenhuma compra registrada pra esses produtos ainda.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" className="height-280">
            <BarChart data={storeData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis
                dataKey="store"
                stroke="var(--color-text-secondary)"
                style={{ fontSize: '12px' }}
                angle={-15}
                textAnchor="end"
                height={60}
              />
              <YAxis
                stroke="var(--color-text-secondary)"
                style={{ fontSize: '12px' }}
                tickFormatter={(value) => `R$${value}`}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar
                dataKey="totalPrice"
                fill="var(--color-primary)"
                radius={[6, 6, 0, 0]}
                name="Valor Total"
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
